import type {
  Course,
  BookmarkEntityResponseCollection,
  BookmarkPage,
  Resource,
} from '@edwin-group/cj-graphql/generated/graphql';
import { GENERATED } from '@edwin-group/cj-graphql';
import { fetchBookmarkPage, fetchUserBookmarks } from '@/services/bookmark/bookmark.service';
import { create } from 'zustand';

const SIZE = 3;
interface BookmarkStoreProps {
  resourcesBookmarks: BookmarkEntityResponseCollection | null;
  resources: Resource[];
  resourcesSize: number;
  showResourcesMoreButton: boolean;

  coursesBookmarks: BookmarkEntityResponseCollection | null;
  courses: Course[];
  coursesSize: number;
  showCoursesMoreButton: boolean;

  page: BookmarkPage | null;

  fetchBookmarks: (type: GENERATED.Enum_Bookmark_Category, size: number) => Promise<void>;
  removeFromBookmark: (type: GENERATED.Enum_Bookmark_Category) => Promise<void>;
  onInit: () => Promise<void>;
  onInitPage: () => Promise<void>;

  handleMore: (type: GENERATED.Enum_Bookmark_Category) => void;
  fetchAndSetPodcasts: () => Promise<void>;
  fetchAndSetResources: () => Promise<void>;
  fetchAndSetCourses: () => Promise<void>;
}

export const useBookmarkStore = create<BookmarkStoreProps>()((set, get) => ({
  podcasts: [],
  podcastsBookmarks: null,
  podcastsSize: SIZE,
  showPodcastsMoreButton: false,

  resources: [],
  resourcesBookmarks: null,
  resourcesSize: SIZE,
  showResourcesMoreButton: false,

  courses: [],
  coursesBookmarks: null,
  coursesSize: SIZE,
  showCoursesMoreButton: false,

  page: null,

  onInit: async () => {
    const { resourcesSize, fetchBookmarks, onInitPage } = get();
    await Promise.all([
      fetchBookmarks(GENERATED.Enum_Bookmark_Category.Resource, resourcesSize),
      //   fetchBookmarks(GENERATED.Enum_Bookmark_Category.Learn, coursesSize),
      onInitPage(),
    ]);
  },
  onInitPage: async () => {
    const pageResponse = await fetchBookmarkPage();
    set({ page: pageResponse.data?.bookmarkPage as BookmarkPage });
  },
  fetchBookmarks: async (type: GENERATED.Enum_Bookmark_Category, size: number) => {
    const bookmarksResponse = await fetchUserBookmarks(type, size);

    if (type === GENERATED.Enum_Bookmark_Category.Resource) {
      set({
        resourcesBookmarks: bookmarksResponse.data?.bookmarks as BookmarkEntityResponseCollection,
        resourcesSize: size,
      });
      get().fetchAndSetResources();
    }
  },
  removeFromBookmark: async (type: GENERATED.Enum_Bookmark_Category) => {
    await get().fetchBookmarks(type, SIZE);
  },
  fetchAndSetPodcasts: async () => {},
  fetchAndSetResources: async () => {
    const { resourcesBookmarks, resourcesSize } = get();

    const resources = resourcesBookmarks?.data.slice(0, resourcesSize);
    if (resources?.length === 0) return set({ resourcesBookmarks: null, resources: [] });

    set({
      resources: resources?.map((resource) => resource.attributes?.metadata as Resource),
      showResourcesMoreButton: (resourcesBookmarks?.meta?.pagination.total || 0) > resourcesSize,
    });
  },
  fetchAndSetCourses: async () => {
    const { coursesBookmarks, coursesSize } = get();

    const courses = coursesBookmarks?.data.slice(0, coursesSize);
    if (courses?.length === 0) return set({ coursesBookmarks: null, courses: [] });

    set({
      courses: courses?.map((course) => course.attributes?.metadata as Course),
      showCoursesMoreButton: (coursesBookmarks?.meta?.pagination.total || 0) > coursesSize,
    });
  },

  handleMore: async (type: GENERATED.Enum_Bookmark_Category) => {
    const size = get().resourcesSize + SIZE;
    await get().fetchBookmarks(type, size);
  },
}));
